import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

interface UseInfiniteScrollOptions {
  fetchNextPage: () => void;
  hasNextPage: boolean;
  isFetching: boolean;
}

export const useInfiniteScroll = ({ fetchNextPage, hasNextPage, isFetching }: UseInfiniteScrollOptions) => {
  const { ref, inView } = useInView({
    threshold: 0.1,
    rootMargin: '0px',
  });

  useEffect(() => {
    if (inView && hasNextPage && !isFetching) {
      fetchNextPage();
    }
  }, [fetchNextPage, inView, hasNextPage]);

  return { ref, inView };
};
